import React from 'react';
import '../assets/styles/Loading.css';

function Loading() {
    return (
        <div className='spinner-overlay' id='animation-overlay'>
            <div className='spinner-overlay__inner'>
                <div className='spinner'>
                    <div className='spinner__bounce spinner__bounce--1'></div>
                    <div className='spinner__bounce spinner__bounce--2'></div>
                    <div className='spinner__bounce spinner__bounce--3'></div>
                </div>
            </div>
        </div>
    );
}

export default Loading;
